import { render, staticRenderFns } from "./AdminPostTermReports.vue?vue&type=template&id=42cc603b"
import script from "./AdminPostTermReports.vue?vue&type=script&lang=js"
export * from "./AdminPostTermReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports